// removed by extract-text-webpack-plugin
module.exports = {"pageHeader":"antd-pro-pageHeader","detail":"antd-pro-detail","row":"antd-pro-row","breadcrumb":"antd-pro-breadcrumb","tabs":"antd-pro-tabs","logo":"antd-pro-logo","title":"antd-pro-title","action":"antd-pro-action","content":"antd-pro-content","extraContent":"antd-pro-extraContent","main":"antd-pro-main"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/PageHeader/index.less
// module id = 375
// module chunks = 0 1